import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { closeModalSelector } from 'modules/dealers/actions';
import BaseModal from 'ui/base/Modal';

import Header from './components/Header';
import SearchPanel from './components/SearchPanel';
import Table from './components/Table';

/** @type {BaseModal} */
export const Modal = styled(BaseModal)`
  .ant-modal {
    height: 90%;
    width: 60% !important;
    @media screen and (max-width: 991px) {
      width: 90% !important;
      height: 90vh !important;
      top: 5vh;
    }
  
    > div {
      height: 100%;
    }
  
    .ant-modal-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0;
      overflow: hidden;
  
      .ant-modal-header {
        flex-shrink: 0;
        margin: 0;
        padding: 16px 0 16px 24px;
      }
  
      .ant-modal-footer {
        flex-shrink: 0;
        margin: 0;
        padding: 0 24px 16px 0;
      }
    }
  
    .ant-modal-footer {
      button:last-child {
        display: none;
      }
    }
  
    .ant-modal-body {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }
`;
/**
 * @typedef {{
 *  meta: Object<string, any>
 * }} Props
 *
 * @param {Props} props
 * @returns {React.FC<Props>}
 */
const ModalDealerSelect = ({ meta }) => {
  const dispatch = useDispatch();

  const handleOnCancel = () => {
    dispatch(closeModalSelector());
  };

  return (
    <Modal
      open
      onCancel={handleOnCancel}
      wrapClassName="dealer-select-modal"
      title={<FormattedMessage id="DealerSelect.selectDealership" defaultMessage="Select a dealership" />}
    >
      <Header />
      <SearchPanel />
      <Table meta={meta} />
    </Modal>
  );
};
export default ModalDealerSelect;
